import type { AppShell } from "@/App"
import { ModuleCatalogTab, type CatalogConfig, type CatalogField } from "@/components/mappings/ModuleCatalogTab"

/**
 * Catálogo das bombas de calor (app-owned) nos Mapeamentos — mesma mecânica
 * do solar (ModuleCatalogTab). Equipamentos levam margem + IVA; acessórios de
 * instalação e mão de obra só IVA (MODULE_NO_MARGIN_ROLES no motor).
 */
type BcKind = "bc_aq" | "bc_aqs"

const KW: CatalogField = { key: "power_kw", label: "kW", type: "num" }
const PHASE: CatalogField = { key: "phase", label: "Fase", type: "phase" }
const TANK: CatalogField = { key: "tank_l", label: "Litros", type: "int" }
const COIL: CatalogField = { key: "coil", label: "Serpentina", type: "bool" }
const LEVEL: CatalogField = { key: "level", label: "Nível", type: "int" }

function fieldsFor(role: string): CatalogField[] {
  if (role === "heat_pump_aq") return [KW, PHASE]
  if (role === "heat_pump_aq_kit") return [KW, PHASE, TANK]
  if (role === "heat_pump_aqs") return [TANK, COIL]
  if (role === "inertia_tank" || role === "dhw_tank") return [TANK]
  if (role.startsWith("installation")) return [LEVEL]
  return []
}

const hasBrand = (role: string) => !role.startsWith("installation") && !role.startsWith("labour")

const intro =
  "Catálogo do simulador de Bombas de Calor. Pesquise para adicionar um produto do CRM ao grupo; a referência liga cada linha ao artigo do Odoo."

const CONFIG: Record<BcKind, CatalogConfig> = {
  bc_aq: {
    kind: "bc",
    intro,
    fieldsFor,
    hasBrand,
    roles: [
      { value: "heat_pump_aq", label: "Bombas de calor (AQ)" },
      { value: "inertia_tank", label: "Depósitos de inércia" },
      { value: "dhw_tank", label: "Termoacumuladores" },
      { value: "installation_aq", label: "Acessórios AQ" },
      { value: "installation_aq_aqs", label: "Acessórios AQ/AQS" },
      { value: "labour_aq", label: "Mão de obra" },
      { value: "heat_pump_aq_kit", label: "Kits (bomba + depósito)" },
    ],
  },
  bc_aqs: {
    kind: "bc",
    intro,
    fieldsFor,
    hasBrand,
    roles: [
      { value: "heat_pump_aqs", label: "Bombas de calor (AQS)" },
      { value: "installation_aqs", label: "Acessórios AQS" },
      { value: "labour_aqs", label: "Mão de obra" },
    ],
  },
}

export function BcCatalogTab({
  shell,
  kind,
  onOpenProduct,
}: {
  shell: AppShell | null
  kind: BcKind
  onOpenProduct?: (productId: number) => void
}) {
  return <ModuleCatalogTab shell={shell} config={CONFIG[kind]} onOpenProduct={onOpenProduct} />
}
